import React from "react";
import { Link } from "react-router-dom";
import { Activity } from "lucide-react";

interface HeaderProps {
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
  description: string;
  action?: { label: string; to: string; icon?: React.ReactNode };
  backLink?: string;
  actionLink?: string;
  actionText?: string;
  actionIcon?: React.ReactNode;
  refreshAction?: () => void;
  refreshText?: string;
  role: "admin" | "doctor";
}

const Header: React.FC<HeaderProps> = ({ title, description, action, role, refreshAction, refreshText }) => {
  const isAdmin = role === "admin";
  return (
    <div
      className={`${
        isAdmin
          ? "bg-white/80 backdrop-blur-lg border-b border-slate-200/50"
          : "bg-white border-b border-gray-200"
      } px-6 py-4 mb-8`}
    >
      <div
        className={`flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 ${
          isAdmin && action?.to.includes("new") ? "" : "max-w-5xl mx-auto"
        }`}
      >
        <div className="flex items-center gap-4">
          <div
            className={`w-12 h-12 ${
              isAdmin ? "bg-gradient-to-r from-blue-500 to-purple-600" : "bg-indigo-600"
            } rounded-xl flex items-center justify-center shadow-lg`}
          >
            <Activity className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1
              className={`text-xl sm:text-2xl font-bold ${
                isAdmin ? "bg-gradient-to-r from-gray-900 to-gray-700 bg-clip-text text-transparent" : "text-gray-800"
              }`}
            >
              {title}
            </h1>
            <p className="text-gray-600 text-sm">{description}</p>
          </div>
        </div>
        {action && (
          <Link
            to={action.to}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg shadow-sm transition-colors ${
              isAdmin && action.to.includes("new")
                ? "bg-gradient-to-r from-blue-500 to-blue-600 text-white hover:from-blue-600 hover:to-blue-700"
                : "bg-gray-50 border border-gray-200 text-gray-700 hover:bg-gray-100"
            }`}
          >
            {action.icon}
            <span className="text-sm font-medium">{action.label}</span>
          </Link>
        )}
        {refreshAction && (
          <button
            onClick={refreshAction}
            className="flex items-center gap-2 px-4 py-2 rounded-lg shadow-sm transition-colors bg-gray-50 border border-gray-200 text-gray-700 hover:bg-gray-100"
          >
            <Activity className="w-4 h-4" />
            <span className="text-sm font-medium">{refreshText || "Actualiser"}</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default Header;